import { isMobile, isTablet } from 'react-device-detect';
import { logger } from './logger';

// Check if running in standalone mode (PWA)
// Check if running in standalone mode (PWA)
const isStandalone =
  typeof window !== 'undefined' &&
  (window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true);

/**
 * Opens a payment link (e.g., Aplus deep link) based on the device type.
 * On mobile/PWA, it uses window.location.href to ensure the app intent is triggered.
 * On desktop, it attempts to open in a new tab.
 *
 * @param url The URL to open (deep link or web link)
 * @param onPopupBlocked Optional callback if popup is blocked on desktop
 */
export const openPaymentLink = (url: string, onPopupBlocked?: () => void) => {
  if (!url) return;

  // Treat Tablets as mobile for this purpose as they likely have the apps installed
  const isMobileDevice = isMobile || isTablet || isStandalone;

  if (isMobileDevice) {
    // For PWA and mobile browsers, window.location.href is more reliable
    // for triggering deep links (app intents) than window.open
    // This navigates the CURRENT window to the deep link
    window.location.href = url;
  } else {
    // Check for Safari on desktop
    const isSafari =
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
      (/Macintosh/i.test(navigator.userAgent) && /Safari/i.test(navigator.userAgent));

    if (isSafari) {
      // Safari often blocks programmatic window.open, so we might need special handling
      // or just try to open and let the caller handle the UI confirmation if needed.
      // Ideally, the caller should have already obtained user gesture if possible.
      const newTab = window.open(url, '_blank', 'noopener,noreferrer');
      if (!newTab) {
        // If popup blocked, we can try redirecting (less ideal for desktop but works)
        // or confirm via callback
        if (onPopupBlocked) {
          onPopupBlocked();
        } else {
          logger.warn('Popup blocked for payment link');
        }
      }
    } else {
      const newTab = window.open(url, '_blank', 'noopener,noreferrer');
      if (!newTab && onPopupBlocked) {
        onPopupBlocked();
      }
    }
  }
};

/**
 * Export a helper to check if we should treat the environment as mobile/PWA
 * This is useful for UI conditional rendering or logic in components.
 */
export const isMobileOrPWA = isMobile || isTablet || isStandalone;
